import Vue from 'vue'
import 'jquery-placeholder'

let hasModel = function (vnode) {
  let model = vnode.data.directives.find(function (o) { // Search the vModelName attached to the element
    return o.name === 'model'
  })

  return typeof model !== 'undefined'
}

Vue.directive('placeholder', {
  inserted: function (el, bindings) {
    let $el = $(el)
    $el.attr('placeholder', bindings.value)
    $el.placeholder()
  },

  update: function (el, bindings, vnode, oldVnode) {
    let $el = $(el)

    if ($el.hasClass('placeholder')) {
      if (!hasModel(vnode)) {
        el.value = $el.val()
      }

      $el.removeClass('placeholder')
      $el.blur()
    }
  }
})



// WEBPACK FOOTER //
// ./src/directives/placeholder/index.js